import { FC, InputHTMLAttributes } from "react";
import classNames from "classnames";
import { EvoInput } from "./EvoInput";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  containerClassName?: string;
};

/** Table toolbar search — icon + theme-aware input (Phase 5). */
export const EvoSearchField: FC<Props> = ({
  className,
  containerClassName,
  placeholder = "Search…",
  ...rest
}) => (
  <div className={classNames("relative min-w-[180px] flex-1", containerClassName)}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[var(--evo-text-secondary)]"
      aria-hidden
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
      />
    </svg>
    <EvoInput
      type="search"
      placeholder={placeholder}
      className={classNames("py-1.5 pl-8 text-sm", className)}
      {...rest}
    />
  </div>
);
